module.exports = __webpack_public_path__ + "static/media/linkCard_charging.516c0e17.svg";